import { render, staticRenderFns } from "./AppleAppStore.vue?vue&type=template&id=14ff75bb&"
import script from "./AppleAppStore.vue?vue&type=script&lang=ts&"
export * from "./AppleAppStore.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports